<template>
    <Modal :show="show" @close="close()">

        <ModalSuccess v-if="success" title="Great news, your kit is on its way!" bodyText="" buttonText="Close window" @close="close()" />
        <Loader v-if="loading" />

        <div class="modal-main" v-if="!success">

            <div class="modal-header">

                <h2 class="modal-title">Send kit to me</h2>
            </div>

            <div class="modal-body">
                <p class="text-center">Sending this kit will result in immediate dispatch to the address below.</p>
                <ModalAddress ref="address" v-model.sync="editedUser" />
            </div>

            <div class="modal-footer">
                <button class="btn btn-primary" v-on:click="onActivate" :disabled="errors.any() || !isValidAddress(editedUser) || loading">Confirm</button>
                <button class="btn plain" v-on:click="close"><em>Cancel</em></button>
            </div>

        </div>

    </Modal>
</template>

<script>
import Modal from '@/components/models/Modal'
import ModalAddress from '@/components/models/components/ModalAddress'
import ModalSuccess from '@/components/models/components/ModalSuccess'
import Loader from '@/components/elements/Loader'
import UserMixins from '@/mixins/userProfile'

export default {
  name: 'ModalActivateAKit',
  props: ['kitID'],
  mixins: [ UserMixins ],
  extends: Modal,
  components: {
    Modal,
    ModalAddress,
    ModalSuccess,
    Loader
  },
  mounted: function () {
    this.editedUser = this.user
  },
  data: function () {
    return {
      isEditing: false,
      editedUser: {
        firstName: '',
        lastName: '',
        addressLine1: '',
        addressLine2: '',
        suburb: '',
        postcode: ''
      },
      loading: false,
      success: false
    }
  },
  computed: {
    user: function () {
      return this.$store.state.GET_USER_RESPONSE || false
    }
  },
  methods: {
    onShow: function () {
      this.loading = false
      this.success = false
      this.editedUser = Object.assign({}, this.user)
    },
    onActivate: function () {
      const payload = {
        kitId: this.kitID,
        addressLine1: this.editedUser.addressLine1,
        addressLine2: this.editedUser.addressLine2,
        suburb: this.editedUser.suburb,
        state: this.editedUser.state,
        postcode: this.editedUser.postcode
      }
      this.loading = true
      this.$store.dispatch('activateKit', payload).then(success => {
        this.$store.dispatch('getUserKits')
        this.$store.dispatch('getSentKits')
        this.success = true
        this.loading = false
      }).catch(error => {
        console.log(error)
        // Refresh regardless
        this.$store.dispatch('getUserKits')
        this.$store.dispatch('getSentKits')
      })
    }
  }
}
</script>

 <style scoped lang="scss">
  .form {
    padding-top: 1rem;
    margin-top: 1rem;
  }

  .modal-body {
      padding-top:0;
  }

  .modal-address {
      padding-top:1.5rem;
      padding-bottom:0rem;
  }
 </style>



// WEBPACK FOOTER //
// src/components/models/ModalActivateAKit.vue